module.exports = __webpack_public_path__ + "static/img/zibo-tj-rwm.e7218c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/skin/footer/zibo-tj-rwm.jpg
// module id = +MOS
// module chunks = 26